import { render, staticRenderFns } from "./AzSocietiesList.vue?vue&type=template&id=354535ba"
import script from "./AzSocietiesList.vue?vue&type=script&lang=js"
export * from "./AzSocietiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports